import React, { Component } from "react";
// import {MDBBadge} from "mdbreact"
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  faAngleDown,
  faStopCircle,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Menu } from "semantic-ui-react";
import domain from "../../domain";
import moment from "moment";
import CheckBox from "./CheckBox";
// import {Link} from "react-router-dom";
import colors from "../../colors";
import axios from "axios";
import help from "../assets/help.png";
import ReactTooltip from 'react-tooltip'
import { data } from "jquery";
// import ReactToolTip from 'react-t'
library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);
var authType = "Basic";
var username = "NhpAdmin";
var password = "nhp@1234";
var basicAuth = authType + btoa(username + ":" + password);
axios.defaults.headers.common["Authorization"] = basicAuth;
export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      margin: props.margin,
      // selected: false,
      color: colors.final_side_sub,
      prevColor: props.color,
      basins: null,
      defaultsubbasin: false,
      subbasin: null,

     //Created for Godavari-Tapi

      volume:null,
      volume_tp:null,
      inflow_waterlevel:null,
      inflow_waterlevel_tp:null,
      rainfall:null,
      rainfall_tp:null,
      forecast:null,
      forecast_tp:null,
      waterlevel:null,
      inflow:null,
      

      catchmentfile:null,
      dsubbasin: null,
      graphdata: null,
      analysisstatus: false,
      subdiv: false,
      mycolor: "blue",
      stationselected: null,
      reservoirsselected:null,
      stationselected_tp: null,
      reservoirsselected_tp:null,
      catchmentdateselected:null,
      catchmentregionselected:null,
      catchmentselected:null,
      catchmentdate:null,
      catchmenttime:null,
      //catchmentregion:null,
      //catchmentcode:null,
      
      datesselected:null,
    };
  }

  onClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      color: !this.state.collapsed
        ? colors["sidebar-sub-menu"]
        : this.state.prevColor,
      subdiv: false,
    });
    if (this.props.clickcount === 0) {
      this.props.incrementCounter();
    } else {
      this.props.incrementCounter();
      this.props.handleTabClick(this.props.data.id);
    }
  };
  // For Reservoir Change Godavari-Tapi
  handleStationChange_R = (e) => {
    let basin;
    let region;
    console.log(this.props.basinselected);
    let date_update =this.props.forecast_date_gd[0].max
    let date_update_tp=this.props.forecast_date_tp[0].max
    this.props.setReservoirChange(e.target.value);
    if (e.target.value !== "#") {
      region=e.target.value
      
      if (this.props.basinselected === "Godavari") {
        basin = "gd";


        /*axios
          .get(`${domain.DBServer}/fetch-HO-Boundary-GD/${e.target.value}`)
          .then((result) => {
            if (result) {
              console.log(result.data);
              this.props.handleStationChange_map(result.data);
            }
          });
        
          try{
          axios
          .get(
            `${domain.DBServer}/fetch-gd-stations-reservoir-info/${e.target.value}/${date_update}`
          )
          .then((result1) => {
            if (result1) {
              // console.log(result1.data[0].region,"DSA");
              // if (result1.data.length > 0) {
                if (Object.keys(result1.data).length > 0) {
                console.log("daiiiiiiiiiiiiiiiiiiiiiiiiiiita",result1.data.length)
                //this.setState({inflow_waterlevel:result1.data})
                this.setInflowWaterlevel(result1.data)
              }
          }
          });

        }
        catch(error){
          console.log("no data found")
        }*/

        try{
          axios
          .get(
            `${domain.DBServer}/fetch-gd-stations-reservoir-inflow-volume-info/${e.target.value}/${date_update}`
          )
          .then((result) => {
            if (result) {
              
              
              // console.log(result1.data[0].region,"DSA");
              // if (result1.data.length > 0) {
                if (Object.keys(result.data).length > 0) {
                  //let region=e.target.value
             // console.log("rrrrrrrrrrrr",region)

                //this.setState({inflow_waterlevel:result1.data})
                this.props.handleStationChartNew(
                  result.data.data2,
                  result.data.data1,date_update,region
            );
              }
          }
          });

        }
        catch(error){
          console.log("no data found")
        }
        
        /*
        let result=   axios
          .get(
            `${domain.DBServer}/fetch-gd-stations-reservoir-volume-info/${e.target.value}/${date_update}`
          ).catch((err)=>{console.log('err'+err)})
          .then((result) => {

            if (result.data.length!==0) {
              console.log( 'test123456789',result.data);
                if (Object.keys(result).length >0) {
                console.log("data",result.data)
                this.setVolume(result.data,date_update)
              }
              else{
                console.log("data not found",result.data,this.state.inflow_waterlevel)
              }
            }
          });
          */
      
      } else if (this.props.basinselected === "Tapi") {
        basin = "tp";

       /* axios
          .get(`${domain.DBServer}/fetch-HO-Boundary-TP/${e.target.value}`)
          .then((result) => {
            if (result) {
              console.log(result.data);
              this.props.handleStationChange_map(result.data);
            }
          });*/
         /* try{
            axios
            .get(
              `${domain.DBServer}/fetch-tp-stations-reservoir-info/${e.target.value}/${date_update_tp}`
            )
            .then((result1) => {
              if (result1) {
                // console.log(result1.data[0].station_name);
                if (result1.data!==[]) {
                  console.log("data",result1.data)
                  this.setState({inflow_waterlevel_tp:result1.data})
                }
              }
            });
  
          }
          catch(error){
            console.log("no data found")
          }*/
            axios
            .get(
              `${domain.DBServer}/fetch-tp-stations-reservoir-info/${e.target.value}/${date_update_tp}`
            )
            .then((result) => {
              if (result) {
                // console.log(result1.data[0].station_name);
                
                    this.props.handleStationChartNew(
                        result.data.data2,
                        result.data.data1,date_update_tp,region
                  );
                    
            
              }
            });
      }
      // let ho = e.target.value;
      }
    };

  //Created for Hydrograph Tapi-Godavari
  handleStationChange = (e) => {
    let basin;
    let region
    console.log(this.props.basinselected);

    this.props.setStationChange(e.target.value);
    if (e.target.value !== "#") {
      region=e.target.value
      if (this.props.basinselected === "Godavari") {
        basin = "gd";
        let date_update =this.props.forecast_date_gd[0].max

       /* axios
          .get(`${domain.DBServer}/fetch-HO-Boundary-GD/${e.target.value}`)
          .then((result) => {
            if (result) {
              console.log(result.data);
              this.props.handleStationChange_map(result.data);
            }
          });
*/
/*
          axios
          .get(
            `${domain.DBServer}/fetch-gd-stations-hydrograph-rainfall-info/${e.target.value}/${date_update}`
          ).catch((err)=>{console.log('err'+err)})
          .then((result1) => {
            if(result1.data!==[]){
            if (Object.keys(result1).length>0){
            if (result1.data!==[] || null) {
              console.log("Rain",result1.data,result1.data.length);
              if (result1.data.length > 0) {
                console.log("data",result1.data)
                this.setState({rainfall:result1.data});
              }
            }
              }
              }
          });*/

          axios
          .get(
            `${domain.DBServer}/fetch-gd-stations-hydrograph-forecast-info/${e.target.value}/${date_update}`
          ).catch((err)=>{console.log('err'+err)})
          .then((result) => {
            if (Object.keys(result).length > 0){
                console.log("data",result.data)
  
                this.props.handleStationChart(
                  result.data.data1,result.data.data2,date_update,region
                );
              
            
          }
          });

      } else if (this.props.basinselected === "Tapi") {
        basin = "tp";
        let date_update_tp =this.props.forecast_date_tp[0].max

       /*
        axios
          .get(`${domain.DBServer}/fetch-HO-Boundary-TP/${e.target.value}`)
          .then((result) => {
            if (result) {
              console.log(result.data);
              this.props.handleStationChange_map(result.data);
            }
          });*/

          /*axios
          .get(
            `${domain.DBServer}/fetch-tp-stations-hydrograph-rainfall-info/${e.target.value}/${date_update_tp}`
          ).catch((err)=>{console.log('err'+err)})
          .then((result1) => {
            if (Object.keys(result1).length > 0){
            if (result1.data!=[] || null) {
              // console.log(result1.data[0].station_name);
              if (result1.data.length > 0) {
                console.log("data",result1.data)
                this.setState({rainfall_tp:result1.data});
              }
              }
            }
          });*/

          axios
          .get(
            `${domain.DBServer}/fetch-tp-stations-hydrograph-forecast-info/${e.target.value}/${date_update_tp}`
          ).catch((err)=>{console.log('err'+err)})
          .then((result) => {
            if (Object.keys(result).length > 0){
          
  
                this.props.handleStationChart(result.data.data1,
                  result.data.data2,date_update_tp,region
                );
              
            
          }
          });

      }
      // let ho = e.target.value;
    }    
  };

  onClickChild2 = (e) => {
    e.preventDefault();
    console.log(e.target.innerText);
    this.props.setSelectedLayer(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );
    this.props.setSelectedMenu(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );

    this.props.setDefaultInfo(this.props.data.information);
    this.setState({
      mycolor: "green",
      mycolor1: "blue",
      mycolor2: "blue",
      mycolor3: "blue",
    });
  };

  onClickChild3 = (e) => {
    e.preventDefault();
    console.log(e.target.innerText);
    this.props.setSelectedLayer(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );

    this.props.setSelectedMenu(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );

    this.props.setDefaultInfo(this.props.data.information);
    this.setState({
      mycolor1: "green",
      mycolor: "blue",
      mycolor2: "blue",
      mycolor3: "blue",
    });
  };

  onClickChild4 = (e) => {
    e.preventDefault();
    console.log(e.target.innerText);
    this.props.setSelectedLayer(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );
    this.props.setSelectedMenu(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );

    this.props.setDefaultInfo(this.props.data.information);
    this.setState({
      mycolor: "blue",
      mycolor1: "blue",
      mycolor2: "green",
      mycolor3: "blue",
    });
  };


 /* setInflowWaterlevel=(value)=>{
    if(value!==null){
    console.log("setinflow",value)
    this.setState({

  inflow_waterlevel:value

    });
  }
  }
  
  setVolume=(value,date_update)=>{
    console.log("value,date",value,date_update,this.state.inflow_waterlevel)
    if(value!==null &&
       this.state.inflow_waterlevel!==null ){
    let  inflowwaterlevel=this.state.inflow_waterlevel
    console.log("setvolume",value,"inflow,",inflowwaterlevel)
    this.props.handleStationChartNew(
      inflowwaterlevel,
      value[0].region,value,date_update
);

this.setState({
  volume:value

    });
  }
  }
*/

  onClickChild5 = (e) => {
    e.preventDefault();
    console.log(e.target.innerText);
    this.props.setSelectedLayer(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );
    this.props.setSelectedMenu(
      this.props.data.name + "_" + e.target.innerText,
      this.props.basinselected
    );

    this.props.setDefaultInfo(this.props.data.information);
    this.setState({
      mycolor: "blue",
      mycolor1: "blue",
      mycolor2: "blue",
      mycolor3: "green",
    });
  };

  onClickChild = () => {
    console.log(this.props.basinselected);

    if (this.props.data.ismap) {
      this.props.toggleSelectedNodeStatus(
        this.props.parent + "-" + this.props.data.name
      );
      this.props.setSelectedMenu(
        this.props.data.name,
        this.props.basinselected
      );

      this.props.enableDatePicker(this.props.data.dateReq);
      this.props.enableSlider(this.props.data.sliderReq);
      //  this.props.enableForecast(this.props.data.forecast)

      this.props.enableForecast(false);

      this.props.setDefaultInfo(this.props.data.information);
    }
    if (this.props.data.issub) {
      console.log(this.props.latestsimulations_names);
      this.props.toggleSelectedNodeStatus(
        this.props.parent + "-" + this.props.data.name
      );
      this.props.setSelectedMenu(
        this.props.data.name,
        this.props.basinselected
      );
      //this.props.setSimulationChange(this.props.latestsimulations_names[0].filename.split(".")[0])
      this.props.enableDatePicker(this.props.data.dateReq);
      this.props.enableSlider(this.props.data.sliderReq);
      this.props.enableForecast(this.props.data.forecast);
      this.props.setDefaultInfo(this.props.data.information);
      let date = moment(this.props.date, "DD MMMM YYYY")
        .add(0, "days")
        .format("DD MMMM YYYY");
      // this.props.setForecastDate(date)
      this.props.setSelectedLayer(
        this.props.data.name +
        "_" +
        moment(date, "DD MMMM YYYY").add(0, "days").format("DD MMMM YYYY"),
        this.props.basinselected
      );
    }

    // if(this.props.isForecast){
    //     console.log(this.props.isForecast)
    //     let date = moment(this.props.date,'DD MMMM YYYY' ).add(this.props.data.name,'days').format("DD MMMM YYYY")
    //     this.props.setForecastDate(date)
    // }
  };

  componentDidMount() {
    // this.props.initializeSelectedNodeStatus(this.props.data.name)if(this.props.)
    if (this.props.data.hasdefault) {
      this.onClick();
    }
    if (
      this.props.selectedLayerLink === this.props.data.name ||
      this.props.data.default
    ) {
      this.onClickChild();
    }
  }

  handleSimulationChange = (e) => {
    
    if(e.target.value!==null) {

    this.props.setSimulationChange(e.target.value);
    }
  };

  handleSimulationChangeNew=(e)=> {

    let catchment_region='#';
    let region='#';
    let code='#';

    if(e.target.value!==null || '#')  {
  this.props.setCatchmentChange(e.target.value);
  catchment_region=e.target.value;
  console.log("catchment_region",catchment_region)
  catchment_region=catchment_region.split("(")
  console.log("catchment_region",catchment_region)
  catchment_region=catchment_region[1].split(")")
  console.log("catchment_region",catchment_region[0])
  catchment_region=catchment_region[0].split(",")
  region=catchment_region[0]
  code=catchment_region[1]
  this.setState({
    catchmentregion:region,
    catchmentcode:code,
  })
  this.props.setSixHourSimulationChange(region)

  this.props.getAvailableDates(region,code)
  
}
  };
  handleSimulationChangeDates=(e)=> {
    let catchmentdatetime;
   // let catchmentdate;
    let catchment_date;
   // let catchmenttime;
   // let catchment_date;
   let time;
   let date;
   
    if(e.target.value) {
    this.props.setDatesChange(e.target.value);
    catchmentdatetime=e.target.value;   
    catchment_date=catchmentdatetime.split(" ");
    date=catchment_date[0];
    time=catchment_date[1];
    this.setState({ catchmentdate:catchment_date[0],
    catchmenttime:catchment_date[1]})
    }
    this.props.getCatchmentRegion(date,time)
  };

//temp=catchmentdateselected.split("(")
//temp=catchmentdateselected.split(")")
  render() {
  
    let subtree = null;
    let stations;
    let stations_tp;
    let reservoirs_tp;
    let reservoirs;
    let catchment;
    let dates_avail='#';
    let simulation_div;
    let filename1
    if (this.props.latestsimulations_names !== null) {
      simulation_div = this.props.latestsimulations_names.map((filename) => {
   
        return <option value={filename}>{filename}</option>;
      });
    }
    if(this.props.stations!==null)
    {
     stations= this.props.stations.map((result)=>{
        return(<option value={result.station_name}>{result.station_name}</option>)
      })
    }
    if(this.props.stations_tp!==null)
    {
     stations_tp= this.props.stations_tp.map((result)=>{
        return(<option value={result.station_name}>{result.station_name}</option>)
      })
    }

    if(this.props.reservoirs!==null)
    {

     reservoirs= this.props.reservoirs.map((result)=>{
        return(<option value={result.station_name}>{result.station}</option>)
      })
    }
    if(this.props.reservoirs_tp!==null)
    {

     reservoirs_tp= this.props.reservoirs_tp.map((result)=>{
        return(<option value={result.station_name}>{result.station_name}</option>)
      })
    }

    if(this.props.catchment!==null)
    {
      console.log("catchment",this.props.catchment)
     catchment= this.props.catchment.map((result)=>{
        return(<option value={result.region}>{result.region}</option>)
      })
    } 
   
    
    if(this.props.dates_avail)
    {
      console.log("dates_avail",this.props.dates_avail)
     dates_avail= this.props.dates_avail.map((result)=>{
        return(<option value={result.date}>{result.date}</option>)
      })
    } 
    if(this.props.catchmentfilename)
    {
      console.log("filename render",this.props.catchmentfilename)
     let  filename= this.props.catchmentfilename
    }

    if(this.props.filename)
    {
      filename1=this.props.filename[0].filename.split(".")
      filename1=filename1[0]
      //this.props.setCatchmentRegion(filename1)
    }

    if (this.props.data.children) {
      subtree = this.props.data.children.map((child, key) => {
        //console.log(child.name==='BasinWise')
        console.log("children",this.props.data.children)

        return (

          <TreeNode
            key={key}
            stations={this.props.stations}
            reservoirs={this.props.reservoirs}
            stations_tp={this.props.stations_tp}
            reservoirs_tp={this.props.reservoirs_tp}

            data={child}
            forecast_date_gd={this.props.forecast_date_gd}
            forecast_date_tp={this.props.forecast_date_tp}

            catchmentregion={this.props.catchmentregion}
            catchmentcode={this.props.catchmentcode}
            catchmentfilename={this.props.catchmentfilename}
            catchment={this.props.catchment}
            dates_avail={this.props.dates_avail}
            handleInundatedMap={this.props.handleInundatedMap}
            handleInundatedVillages={this.props.handleInundatedVillages}
            incrementCounter={this.props.incrementCounter}
            latestsimulations_names={this.props.latestsimulations_names}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            margin={this.state.margin + 5}
            color={this.state.color}
            setSimulationChange={this.props.setSimulationChange}
            setSixHourSimulationChange={this.props.setSixHourSimulationChange}
            selectedLayerLink={this.props.selectedLayerLink}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStaus={this.props.selectedNodeStaus}
            parent={this.props.data.name}
            enableDatePicker={this.props.enableDatePicker}
            enableSlider={this.props.enableSlider}
            enableForecast={this.props.enableForecast}
            isForecast={this.props.data.forecast}
            date={this.props.date}
            setDefaultInfo={this.props.setDefaultInfo}
            setDate={this.props.setDate}
            basinselected={this.props.basinselected}
            setBasinSelected={this.props.setBasinSelected}
            stationHeight={this.props.stationHeight}
           
            getAvailableDates={this.props.getAvailableDates}
            getCatchmentRegion={this.props.getCatchmentRegion}
            setCatchmentRegion={this.props.setCatchmentRegion}

            setStationChange={this.props.setStationChange}
            setReservoirChange={this.props.setReservoirChange}
            //setStationChange_tp={this.props.setStationChange_tp}
            //setReservoirChange_tp={this.props.setReservoirChange_tp}
            setCatchmentChange={this.props.setCatchmentChange}
            setDatesChange={this.props.setDatesChange}

            stationselected={this.props.stationselected}
            reservoirsselected={this.props.reservoirsselected}

            stationselected_tp={this.props.stationselected_tp}
            reservoirsselected_tp={this.props.reservoirsselected_tp}
            catchmentselected={this.props.catchmentselected}
            datesselected={this.props.datesselected}
            inundationmapstatus={this.props.inundationmapstatus}
            handleTabClick={this.props.handleTabClick}
            active={this.props.active}
            simulationselected={this.props.simulationselected}
            clickcount={this.props.clickcount}
            station_height={this.props.station_height}

            handleStationChange_map={this.props.handleStationChange_map}
            handleStationChart={this.props.handleStationChart}
            handleStationChartNew={this.props.handleStationChartNew}
          />
        );
      });
    }

    if (subtree) {
      return (
        <div className="modalwindow">
          <div
            as="div"
            data-id={this.props.data.id}
            onClick={this.onClick}
            className="modalheader"
            style={{ textAlign: "left" }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ width: "80%" }}>{this.props.data.displayname}</div>
              <div style={{ textAlign: "right", width: "20%" }}>

                {this.props.active ? (
                  <FontAwesomeIcon icon="angle-down" />
                ) : (
                    <FontAwesomeIcon icon="angle-right" />
                  )}
              </div>
            </div>
          </div>

          {this.props.active ? (
            <div style={{ background: colors["final_side_inner"] }}>
              {subtree}
            </div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div
          style={{
            background: colors["final_side_inner"],
            padding: "0px",
            color: colors.text_sub_color,
          }}
        >
          {this.props.data.displayname !== "#"  && this.props.basinselected==="Godavari" ? (
            <Menu.Item
              as="div"
              data-id={this.props.data.id}
              onClick={this.onClickChild}
              style={{ 
              width: "90%",
             marginleft:"20px",
              color:
                (this.props.inundationmapstatus === "0" &&
                  this.props.data.name === "Event Simulation") || (this.props.data.name === "6 Hourly Simulations" && this.props.basinselected==='Godavari')
                  ? true
                  : false
              }
            }
            >
              <div style={{ display: "flex", color: colors.text_sub_color }}>
                {console.log(
                  this.props.selectedNodeStaus[
                  this.props.parent + "-" + this.props.data.name
                  ]
                )}
                {this.props.data.ismap  ? (
                  <div style={{ width: "10%", color:colors.text_color }}>
                    {this.props.selectedNodeStaus[
                      this.props.parent + "-" + this.props.data.name
                    ] ? (
                        <FontAwesomeIcon icon="stop-circle" />
                      ) : (
                        <FontAwesomeIcon icon="circle" />
                      )}
                  </div>
                ) : this.props.data.issub ? (
                  <div style={{ width: "10%", color:colors.text_color }}>
                    {this.props.selectedNodeStaus[
                      this.props.parent + "-" + this.props.data.name
                    ] ? (
                        <FontAwesomeIcon icon="stop-circle" />
                      ) : (
                        <FontAwesomeIcon icon="circle" />
                      )}
                  </div>
                ) : null}

                <div
                  style={{
                    width: "90%",
                     marginleft:"20px",
                    color:
                    (this.props.inundationmapstatus === "0" &&
                    this.props.data.name === "Event Simulation") || (this.props.data.name === "6 Hourly Simulations" && this.props.basinselected==='Tapi')
                        ? true
                        : false
                  }}
                >
                  {this.props.data.displayname}
                </div>
              </div>
            </Menu.Item>
          ) : null}


          {this.props.data.issub && this.props.data.name === "Hydrograph" && this.props.basinselected==='Godavari' ? (
            <div style={{ textAlign: "left" }}>
            
                <div class="modalbox">

                      <select
                        onChange={this.handleStationChange}
                        value={this.props.stationselected}
                        selected={this.props.stationselected}
                      >
                        <option value="#">Select Station</option>
                                              {stations}
                      </select>
                 
                   
                      {this.props.station_height!==null?<span>Highest Flood Discharge<span style={{color:"blue",fontWeight:"strong"}}> {Number(this.props.station_height).toLocaleString('en-IN')} </span> (cumecs)</span>:null}
                </div>
            </div>

          ) : null}





{this.props.data.issub && this.props.data.name === "Hydrograph" && this.props.basinselected==='Tapi' ? (
            <div style={{ textAlign: "left" }}>
            
                <div class="modalbox">

                      <select
                        onChange={this.handleStationChange}
                        value={this.props.stationselected}
                        selected={this.props.stationselected}
                      >
                        <option value="#">Select Station</option>
                                              {stations_tp}
                      </select>
                 
                   
                      {this.props.station_height!==null?<span>Highest Flood Discharge<span style={{color:"blue",fontWeight:"strong"}}> {Number(this.props.station_height).toLocaleString('en-IN')} </span> (cumecs)</span>:null}
                </div>
            </div>

          ) : null}

{this.props.data.issub && this.props.data.name === "Reservoir" && this.props.basinselected==="Godavari"? (
   
   <div style={{ textAlign: "left" }}>
   
   <div class="modalbox">
       <select
       onChange={this.handleStationChange_R}
       value={this.props.reservoirsselected}
       selected={this.props.reservoirsselected}
       >
         <option value="#">
           Select Reservoir
         </option>
         {reservoirs}
       </select>
       
       </div>
   </div>
   
 ) : null}

     {this.props.data.issub && this.props.data.name === "Reservoir" && this.props.basinselected==="Tapi"? (
   
            <div style={{ textAlign: "left" }}>
            
            <div class="modalbox">
                <select
                onChange={this.handleStationChange_R}
                value={this.props.reservoirsselected}
                selected={this.props.reservoirsselected}
                >
                  <option value="#" selected>
                    Select Reservoir
                  </option>
                  {reservoirs_tp}
                </select>
                
                </div>
            </div>
            
          ) : null}


       {this.props.data.issub &&
            this.props.selectedNodeStaus[
            this.props.parent + "-" + this.props.data.name
            ] &&
            this.props.data.name === "Event Simulation" && this.props.basinselected==='Godavari'  ? (
             <div style={{marginLeft:"50px"}}>
                <a href='https://bhuvan-app1.nrsc.gov.in/flood_animation' target='_blank'>Event Simulation</a><br/>
              </div>
            
            ) : null }



    {this.props.data.issub &&
            this.props.selectedNodeStaus[
            this.props.parent + "-" + this.props.data.name
            ] &&
            this.props.data.name === "6 Hourly Simulation" &&
            this.props.inundationmapstatus === "0"  && this.catchmentdateselected!=='#' || null ? (
              <div class="modalbox">
                
                
              
                <select
                    onChange={this.handleSimulationChange}
                    selected={this.props.simulationselected}
                    value={this.props.simulationselected}
                  >
                    <option value="#">Select Date</option>
                    <option value='2022-14-07'>'2022-14-07'</option>
                  </select>
              </div>
            ) : this.props.data.issub &&
              this.props.selectedNodeStaus[
              this.props.parent + "-" + this.props.data.name
              ] &&
              this.props.data.name === "6 Hourly Simulations" && this.props.basinselected==='Godavari' ? (
                <div class="modalbox">


                  <select
                    onChange={this.handleSimulationChangeNew}
                    selected={this.props.catchmentselected}
                    value={this.props.catchmentselected}
                  >
                    <option value="#">Select Catchment</option>
                    {catchment}
                  </select> 
                  
                  {this.props.data.name === "6 Hourly Simulations" && this.props.basinselected==='Godavari' && this.catchmentdateselected!=='#' || null? (


                  <select
                  onChange={this.handleSimulationChangeDates}
                  selected={this.props.datesselected}
                  value={this.props.datesselected}
                >
                  <option value="#">Select Date</option>
                  {dates_avail}
                </select>
    ):null}
             
                </div>
              ) : null}
          

        </div>
        
      );
      
    }

  }
  
}

